<template>
  <div class="requirements__wrapper">
    <Accordion
      v-for="category in requirements"
      :id="category.tid"
      :key="category.tid"
      :full="full"
      :active="true"
      :dir-button="true"
      :dir-button-left="true"
      :title="category.categoryName"
      size="accordion-heading"
      class="requirements__body"
      level="requirement"
      @loadLicenses="accordionChange"
      @initiallyExpanded="accordionChange"
    >
      <template slot="title">
        <div class="title-slot-wrapper">
          <TitleBlock
            :text="category.categoryName"
            color="white"
            size="accordion-heading"
            :padding="false"
          />
          <el-button
            v-if="workspaceAccess"
            class="checklist-button"
            @click.stop="showChecklistDialog(category.tid)"
          >
            <Icon :icon="'plus'" class="plus-icon" />
            Add to checklist
          </el-button>
        </div>
      </template>
      <div
        v-for="topic in category.children"
        :key="topic.tid"
        class="requirements__inner"
      >
        <h2 class="heading">
          {{ topic.categoryName }}
        </h2>

        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="hasAccess"
          v-html="externalLinks(topic.requirement.content)"
        />
        <!-- eslint-enable vue/no-v-html -->
        <div v-else class="unauthorised">{{ noAccessShort }}</div>
        <div v-if="topic.requirement.licenses.length > 0 && reports">
          <i
            >Relevant to:&nbsp;
            <span
              v-for="(license, lKey) in topic.requirement.licenses"
              :key="lKey"
            >
              {{ license
              }}{{ hasComma(lKey, topic.requirement.licenses.length) }}
            </span>
          </i>
        </div>
        <div v-for="(ref, index) in topic.requirement.references" :key="index">
          <a v-if="hasAccess" :href="ref.uri">{{ ref.title }}</a>
        </div>
        <!--<div>
          Last updated:
          <strong>{{ fixDate(topic.requirement.publishDate) }}</strong>
        </div>-->
        <RequirementHistory :requirements="topic.requirement.history" />
      </div>
      <!--  v-if to reinstantiate on reuse  -->
      <ChecklistDialog
        v-if="categoryChecklistDialogVisible[category.tid] ?? false"
        @update:visible="categoryChecklistDialogVisible[category.tid] = $event"
        :visible="categoryChecklistDialogVisible[category.tid] ?? false"
        :topics="childCategoriesToTopics(category.tid)"
        @submit="submitChecklist(category.tid, $event)"
      />
    </Accordion>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { months } from "../../config";
import { links } from "../../mixin/links";
import { checkAccess, noAccessShort } from "@/utils/constants";
import TitleBlock from "~/components/elements/TitleBlock.vue";
import Icon from "~/components/elements/Icon.vue";
import ChecklistDialog from "~/components/checklists/ChecklistDialog.vue";
// import {links} from "@/mixin/links";

export default {
  name: "RequirementList",
  components: {
    ChecklistDialog,
    Icon,
    TitleBlock,
    // TitleBlock: () => import("../elements/TitleBlock"),
    // Title: () => import("../elements/Title"),
    // Info: () => import("../elements/Info"),
    Accordion: () => import("../elements/Accordion"),
    RequirementHistory: () => import("../elements/RequirementHistory"),
  },
  mixins: [links],
  props: {
    jurisdiction: {
      type: Number,
      default: null,
    },
    categoryParent: {
      type: Number,
      default: null
    },
    requirements: {
      type: Array,
      default: null,
    },
    reports: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      months,
      noAccessShort,
      accessChecked: false,
      categoryChecklistDialogVisible: {},
    };
  },
  computed: {
    ...mapState("Auth", ["subscriptions"]),
    ...mapGetters("Auth", ["workspaceAccess"]),
    hasAccess(state) {
      const access = checkAccess(state.subscriptions.legacy_permissions, "viewRequirement") || checkAccess(state.subscriptions.permissions, "requirements");
      if (
        typeof window !== "undefined" &&
        window !== undefined &&
        window._paq &&
        !this.accessChecked
      ) {
        this.accessChecked = true;
        if (access === false) {
          window._paq.push([
            "trackEvent",
            "AccessDenied",
            "NoPermissions",
            this.$router.currentRoute.path,
            "",
          ]);
        }
      }
      return access;
    },
  },

  methods: {
    hasComma(i, l) {
      return i < l - 1 ? "," : "";
    },
    trackRequirementView(id) {
      if (this.$matomo) {
        this.requirements.forEach((category) => {
          if (category.tid === id) {
            const concatNids = category.children
              .map((child) => child.requirement.nid)
              .join(",");
            this.$matomo.trackEvent("RequirementView", "View", concatNids);
          }
        });
      }
      if (this.$churnZero) {
        this.$churnZero.trackEvent("RequirementView", "View");
      }
    },
    accordionChange(id, pid, jurisdictionParent, level) {
      this.trackRequirementView(id);
    },
    // externalLinks(text) {
    //   const search = '<a ';
    //   const replaceWith = '<a target="_blank" ';
    //   const result = text.split(search).join(replaceWith);
    //   return result;
    // },
    fixDate(val) {
      let date = "";
      if (val) {
        const text = val.trim();
        const newText = text.substring(0, 10).replace(/-/g, "/");
        const newDate = new Date(newText);
        const day = newDate.getDate();
        const month = newDate.getMonth();
        const year = newDate.getFullYear();
        const monthName = this.months.find((el) => el.id === month);
        if (monthName) {
          date =
            (day < 10 ? `0${day}` : day) +
            " " +
            (this.min ? monthName.shortname : monthName.name) +
            " " +
            year;
        }
      }
      return date;
    },
    childCategoriesToTopics(tid) {
      const mainCategory = this.requirements.filter(category => category.tid === tid);
      if (mainCategory.length === 0) {
        return [];
      }

      return mainCategory.at(0).children?.map(category => {
        return { id: category.tid, label: category.categoryName };
      });
    },
    showChecklistDialog(tid) {
      this.$set(this.categoryChecklistDialogVisible, tid, true);
    },
    submitChecklist(tid, data) {
      const payload = {
        data: {
          categoryTids: [tid],
          topicTids: data.selectedTopics,
          newChecklist: data.newChecklist,
        },
        queryString: `filter[jurisdiction]=${this.jurisdiction}&filter[licences]=${this.categoryParent}`
      };
      if(data.newChecklist) {
        payload.data.name = data.checklistName;
        payload.data.description = data.description;
      } else {
        payload.data.checklistId = data.selectedChecklist;
      }
      // Placeholder data, might differ in a bit.
      this.$store
        .dispatch("Workspace/requirementChecklist", payload)
        .then((response) => {
          // Success notification with proper response handling
          this.$notify({
            title: "Added to Workspace",
            message:
              `<br><a href="${this.$config.workspaceFEURL}/checklist/${response.data.checklistId}"
               target="_blank"
               class="notification-link">
          View Checklist
          </a>
          `,
            type: "success",
            dangerouslyUseHTMLString: true,
            duration: 8000,
            customClass: "persistent-notification"
          });

          this.categoryChecklistDialogVisible[tid] = false;
        })
        .catch((e) => {
          console.error(e);
          this.$message({
            type: "error",
            message: `Failed to ${payload.newChecklist ? "create" : "update"} checklist. Please try again.`,
          });
          this.categoryChecklistDialogVisible[tid] = false;
        });
    }
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.requirements {
  &__wrapper {
    margin-left: 2rem;
  }

  &__body {
    // padding-top: 3rem;
    margin-left: 3rem;

    .heading {
      font-size: 2.2rem;
      font-weight: bold;
    }
  }

  &__inner {
    // padding-top: 3rem;
    padding-left: 7.4rem;
    border-left: dotted 1px $border;
    padding-top: 3rem;

    .heading {
      font-size: 1.8rem;
      font-weight: 700;
    }
  }

  .title-slot-wrapper {
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .checklist-button {
      background-color: white;
      color: $corporateBlue;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 8px 12px;
      border-radius: 8px;
      border: 1px solid $corporateBlue;
      // 20 according to figma, 18 looks more centered
      line-height: 18px;
      font-size: 14px;
      font-weight: 400;
      gap: 4px;
      width: auto;
      // Some extra hacks to get it properly positioned within the accordion heading.
      height: 100%;
      margin-top: -6px;

      .plus-icon {
        width: 20px;
        height: 20px;
        margin: 0;
        align-self: flex-start;
      }
    }
  }
}

.persistent-notification {
  animation: slideInOut 10s forwards !important;
  transition: none !important;
  pointer-events: all !important; // Ensure click events work

  .notification-link {
    color: $accentBlue;
    text-decoration: underline;
    font-weight: bold;

  }
}

@keyframes slideInOut {
  0% { transform: translateX(100%); opacity: 0; }
  10% { transform: translateX(0); opacity: 1; }
  90% { transform: translateX(0); opacity: 1; }
  100% { transform: translateX(100%); opacity: 0; }
}
</style>
